'use client';

import { Button, ExpandableCallout, TextButton } from '@galapagos/design-system/web';
import { useTranslation } from 'react-i18next';
import { useSignupNavigation } from '../../hooks/useSignupNavigation';
import { useStepHeading } from '../../hooks/useStepHeading';
import { wrapUpExitStep } from '../../wrap-up/branching';
import { useWrapUpContext } from '../../wrap-up/useWrapUpContext';
import { gated } from './gated';
import { WrapUpActions, WrapUpFrame } from './WrapUpFrame';
import { WRAP_UP_PICTURES, WrapUpPicture } from './WrapUpPicture';

/** `/hdhp-notice/`: the high-deductible notice; book the free call or skip it. */
function HdhpNoticeStep() {
  const { t } = useTranslation('signup');
  const title = t('wrapUp.hdhpNotice.title');
  const headingRef = useStepHeading(title);
  const state = useWrapUpContext();
  const { goToStep } = useSignupNavigation();
  return (
    <WrapUpFrame
      title={title}
      description={t('wrapUp.hdhpNotice.description')}
      headingRef={headingRef}
    >
      <ExpandableCallout
        title={t('wrapUp.hdhpNotice.whyTitle')}
        actionId="signup.hdhp-notice-why.toggle"
        data-testid="signup-hdhp-notice-why-callout"
      >
        <p className="signup-step__text">{t('wrapUp.hdhpNotice.whyBody')}</p>
      </ExpandableCallout>
      <WrapUpPicture
        tone="cream"
        size="illustration"
        src={WRAP_UP_PICTURES.walking}
        data-testid="signup-hdhp-notice-picture"
      />
      <WrapUpActions>
        <Button
          size="L"
          type="Primary"
          label={t('wrapUp.hdhpNotice.book')}
          actionId="signup.hdhp-notice-book.activate"
          data-testid="signup-hdhp-notice-book-button"
          state={state.ready ? 'Default' : 'Loading'}
          onPress={() => {
            // The free cost call with Member Support replaces the welcome call here.
            if (state.ready) goToStep('hdhp-booking');
          }}
        />
        <TextButton
          label={t('wrapUp.hdhpNotice.skip')}
          actionId="signup.hdhp-notice-skip.activate"
          data-testid="signup-hdhp-notice-skip-button"
          // Waits for the context like Book does: a minor's skip ends on
          // "registered", so it must not guess the adult exit on a slow read.
          loading={!state.ready}
          onPress={() => {
            if (state.ready) goToStep(wrapUpExitStep(state.context));
          }}
        />
      </WrapUpActions>
    </WrapUpFrame>
  );
}

export const HdhpNoticeScreen = gated(HdhpNoticeStep, 'hdhp-notice');
